/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTypography = createReactComponent("typography", "IconTypography", [
  ["path", { d: "M4 20l3 0", key: "svg-0" }],
  ["path", { d: "M14 20l7 0", key: "svg-1" }],
  ["path", { d: "M6.9 15l6.9 0", key: "svg-2" }],
  ["path", { d: "M10.2 6.3l5.8 13.7", key: "svg-3" }],
  ["path", { d: "M5 20l6 -16l2 0l7 16", key: "svg-4" }]
]);

export { IconTypography as default };
//# sourceMappingURL=IconTypography.js.map
